import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilterPipe',
  pure: true
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, attr: string, page?: any): any[] {
    if (!items) return [];
    if (!searchText) return items;
    return this.searchItems(items, searchText.toLowerCase(), attr, page);
  }

  private searchItems(items: any[], searchText: string, attr: string, page?: any): any[] {
    page ? page.currentPage = 1 : '';
    const results: any[] = [];
    searchText = searchText.replace(/\s/g, "").toLowerCase(); // Use replace instead of replaceAll for better compatibility

    items.forEach(it => {
      // Handle nested properties like 'conversion.description'
      const attrValue = this.getNestedValue(it, attr);

      if (attrValue?.toString()?.replace(/\s/g, "").toLowerCase()?.includes(searchText)) {
        results.push(it);
      }
    });
    return results;
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, property) => {
      return current && current[property] !== undefined ? current[property] : null;
    }, obj);
  }
}
